'use client';

import { useTranslations } from 'next-intl';
import clsx from 'clsx';
import { ProductDetailCarousel } from '@headless-workspace/domain/common/client';
import {
    ProductRecommendationCTA,
    TileProductAvailabilityValue,
    VipBrandsValue,
} from '@headless-workspace/domain/common/server';
import { GlowContainerSection, PropsWithFontFamily, PropsWithId, PropsWithLocale } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';

type ProductDetailCarouselContainerProps = PropsWithLocale &
    PropsWithFontFamily &
    PropsWithId & {
        vipBrands: VipBrandsValue;
        products: TileProductAvailabilityValue[];
        title: string | undefined;
        enablePriceExceptionLegalMentions: boolean;
        button: ProductRecommendationCTA | undefined;
    };

export const ProductDetailCarouselContainer: Component<ProductDetailCarouselContainerProps> = ({
    locale,
    vipBrands,
    products,
    title,
    fontFamily,
    enablePriceExceptionLegalMentions,
    button,
}) => {
    const t = useTranslations('Discover.Pdp.carousel');

    return (
        <section className={clsx('flex-col justify-center items-center')}>
            <GlowContainerSection
                className={clsx('gap-1.5 tablet:gap-2 desktop:px-1.5 tablet:px-1')}
                titleContainerClassName={'px-1 desktop:px-4'}
                title={title}
                button={button}
                fontFamily={fontFamily}
                titleClassName={'line-clamp-2'}
            >
                <ProductDetailCarousel
                    products={products}
                    prevBtnAriaLabel={t('ariaLabel.prevBtn')}
                    nextBtnAriaLabel={t('ariaLabel.nextBtn')}
                    wishlistBtnAriaLabel={t('ariaLabel.wishlist')}
                    thumbArialLabel={t('ariaLabel.thumb')}
                    locale={locale}
                    navigationButtonClassName={'hidden desktop:block'}
                    vipBrands={vipBrands}
                    enablePriceExceptionLegalMentions={enablePriceExceptionLegalMentions}
                />
            </GlowContainerSection>
        </section>
    );
};
